/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EffectiveAnnualCostFigures } from './EffectiveAnnualCostFigures';
import {
    EffectiveAnnualCostFiguresFromJSON,
    EffectiveAnnualCostFiguresFromJSONTyped,
    EffectiveAnnualCostFiguresToJSON,
} from './EffectiveAnnualCostFigures';

/**
 * 
 * @export
 * @interface EffectiveAnnualCost
 */
export interface EffectiveAnnualCost {
    /**
     * 
     * @type {EffectiveAnnualCostFigures}
     * @memberof EffectiveAnnualCost
     */
    investmentManagementCharges: EffectiveAnnualCostFigures;
    /**
     * 
     * @type {EffectiveAnnualCostFigures}
     * @memberof EffectiveAnnualCost
     */
    adviceCharges: EffectiveAnnualCostFigures;
    /**
     * 
     * @type {EffectiveAnnualCostFigures}
     * @memberof EffectiveAnnualCost
     */
    administrationCharges: EffectiveAnnualCostFigures;
    /**
     * 
     * @type {EffectiveAnnualCostFigures}
     * @memberof EffectiveAnnualCost
     */
    otherCharges: EffectiveAnnualCostFigures;
    /**
     * 
     * @type {EffectiveAnnualCostFigures}
     * @memberof EffectiveAnnualCost
     */
    total: EffectiveAnnualCostFigures;
    /**
     * 
     * @type {string}
     * @memberof EffectiveAnnualCost
     */
    planName: string;
    /**
     * 
     * @type {string}
     * @memberof EffectiveAnnualCost
     */
    planNumber: string;
}

/**
 * Check if a given object implements the EffectiveAnnualCost interface.
 */
export function instanceOfEffectiveAnnualCost(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentManagementCharges" in value;
    isInstance = isInstance && "adviceCharges" in value;
    isInstance = isInstance && "administrationCharges" in value;
    isInstance = isInstance && "otherCharges" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "planName" in value;
    isInstance = isInstance && "planNumber" in value;

    return isInstance;
}

export function EffectiveAnnualCostFromJSON(json: any): EffectiveAnnualCost {
    return EffectiveAnnualCostFromJSONTyped(json, false);
}

export function EffectiveAnnualCostFromJSONTyped(json: any, ignoreDiscriminator: boolean): EffectiveAnnualCost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentManagementCharges': EffectiveAnnualCostFiguresFromJSON(json['InvestmentManagementCharges']),
        'adviceCharges': EffectiveAnnualCostFiguresFromJSON(json['AdviceCharges']),
        'administrationCharges': EffectiveAnnualCostFiguresFromJSON(json['AdministrationCharges']),
        'otherCharges': EffectiveAnnualCostFiguresFromJSON(json['OtherCharges']),
        'total': EffectiveAnnualCostFiguresFromJSON(json['Total']),
        'planName': json['PlanName'],
        'planNumber': json['PlanNumber'],
    };
}

export function EffectiveAnnualCostToJSON(value?: EffectiveAnnualCost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentManagementCharges': EffectiveAnnualCostFiguresToJSON(value.investmentManagementCharges),
        'AdviceCharges': EffectiveAnnualCostFiguresToJSON(value.adviceCharges),
        'AdministrationCharges': EffectiveAnnualCostFiguresToJSON(value.administrationCharges),
        'OtherCharges': EffectiveAnnualCostFiguresToJSON(value.otherCharges),
        'Total': EffectiveAnnualCostFiguresToJSON(value.total),
        'PlanName': value.planName,
        'PlanNumber': value.planNumber,
    };
}

